$(function() {
    const $header = document.querySelector('.page-header');

    //Sticky-header
    function stickyHeader() {
        if($(window).scrollTop() > 0) {
            $header.classList.add('sticky');
        } else {
            $header.classList.remove('sticky');
        }
    }

    document.addEventListener('scroll', () => {
        stickyHeader();
    });

    /* --- MOBILE MENU LOGIC --- */
    const burger = document.querySelector('.page-header__burger');
    const mobileMenu = document.querySelector('.mobile-menu');
    const body = document.body;

    // Toggle Mobile Menu (Burger & Overlay)
    if (burger && mobileMenu) {
        burger.addEventListener('click', function () {
            this.classList.toggle('is-active');
            mobileMenu.classList.toggle('is-active');
        
            // Lock body scroll when menu is open
            if (mobileMenu.classList.contains('is-active')) {
                body.style.overflow = 'hidden';
            } else {
                body.style.overflow = '';
            }
        });
    }

    // Mobile Accordion Logic
    // Find all list items in the mobile menu that have a sub-menu
    const menuItemsWithChildren = document.querySelectorAll('.mobile-nav .menu-item-has-children');

    menuItemsWithChildren.forEach(function (item) {
        // Create the Plus Button Trigger
        const toggleBtn = document.createElement('span');
        toggleBtn.className = 'submenu-toggle';
    
        // Append plus button to the LI
        item.appendChild(toggleBtn);

        // Click Event for the Plus Button
        toggleBtn.addEventListener('click', function (e) {
            e.preventDefault();
            item.classList.toggle('submenu-open');
            const subMenu = item.querySelector('.sub-menu');
        
            if (subMenu) {
                if (subMenu.style.display === 'block') {
                    subMenu.style.display = 'none';
                } else {
                    subMenu.style.display = 'block';
                }
            }
        });
    });
    /* --- End MOBILE MENU LOGIC --- */
});